import { ProductClick } from './interfaces';

export const mockClickData: ProductClick = {
  category: 'Solid Waste Cart',
  id: 'RES_MSW',
  list: 'test',
  name: 'Solid Waste Cart',
  position: 5,
  price: 17.65,
  purchasable: true,
  unPurchasableReasons: [],
};

export const mockCartViewSolidWasteRecycleBundleResMrnProductClickData: ProductClick =
  {
    category: 'Solid Waste and Recycling',
    gisFeature: [],
    id: '000.00_RES_MRN',
    initialDeposit: 50,
    measurements: '',
    monthlyAmount: 24.0896,
    name: 'Solid Waste & Recycling Bundle',
    oneTimeDeliveryAmount: 94,
    position: 0,
    quantity: 2,
    sizeDescription: '',
    terms: '24-Month Service Agreement',
    tons: 0,
    totalPrice: 24.0896,
  };
